import * as React from "react";
import { connect } from "react-redux";
import { Link, withRouter, Redirect } from "react-router-dom";
import CircularProgressbar from "../common/CircularProgressbar";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import Spinner from "../common/spinner";
import SectionLoadingError from "../common/SectionLoadingError";
import StatusBanner from '../common/StatusBanner';
import WellnessGoals from './WellnessGoals';
import NotAuthorized from '../common/NotAuthorized';

class WellnessReport extends React.Component {

    constructor(props) {
        super(props);
        const { wellnessDueDate } = this.props.serverData;
        const currentYear = new Date(wellnessDueDate).getFullYear();
        this.state = { currentYear: currentYear, openGetstartedModal: false };
    }

    componentDidMount() {
        this.props.getWellnessReportV2(this.props.userToken, this.state.currentYear);
        logUI("MBHWeb.UI.WellnessReport.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    tryAgain = (e) => {
        e.preventDefault();
        this.setState({ tryAgain: true });
        logUI("MBHWeb.UI.WellnessReport.onTryAgain", new Date(), Tools.getURLPath());
    }

    render() {
        const { dcjSelfOrderPending, dcjSelfOrderFailure, isProxyUser, report } = this.props;
        const { tryAgain, currentYear } = this.state;
        let currentYearReport = report && report.length > 0 && report.filter(item => item.year === currentYear)[0];
        let results = [];
        const defaultScoreColor = "#008fbe";
        const { pledge, discussionPoints, overallScoreInterpretation, overallScore } = currentYearReport || {};
        if (currentYearReport && currentYearReport.results && currentYearReport.results.length > 0) {
            results = currentYearReport.results.map((r, i) => {
                return (
                    <div className="col-4" key={"results_" + i}>
                        <div className="row">
                            <div className="col-12">{r.name}</div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <CircularProgressbar percentage={r.score} overallScoreColor={r.scoreColor || defaultScoreColor} rotation={0.00} />
                            </div>
                        </div>
                    </div>
                );
            });
        }

        let discussion = [];
        let hasDiscussion = false;
        if (discussionPoints && discussionPoints.length > 0) {
            discussion = discussionPoints.map((d, i) => {
                hasDiscussion = true;
                return (
                    <React.Fragment key={"discussion_" + i}>
                        {
                            hasDiscussion === true &&
                            <li key={"discussionPoints_" + i}>{d}</li>
                        }
                    </React.Fragment>
                );
            });
        }
        return (isProxyUser ? <NotAuthorized /> : <div className={`container-fluid body-content full-width${dcjSelfOrderFailure && !tryAgain ? " wellness-report-error-container" : " wellness-report-container"}`}>
            <div className="row">
                <div className="col-12">
                    {this.props.reportPending === true || dcjSelfOrderPending ? <Spinner /> :
                        dcjSelfOrderFailure && !tryAgain ? <div className="row"><div className="col-12">
                            <StatusBanner bannerMsg="Sorry, we are unable to start the journey." failedStatus>
                                <span>Please <Link to="/WellnessReport" onClick={e => this.tryAgain(e)}>try again</Link> later.</span>
                            </StatusBanner>
                        </div>
                        </div> :
                            (this.props.reportError ?
                                <SectionLoadingError message="Sorry, we are not able to display your report. Please try again later." />
                                :
                                this.props.reportSuccess === true &&
                                <React.Fragment>
                                    <div className="row well-being__score">
                                        <div className="col-12 maxWidth-content">
                                            <div className="row">
                                                <div className="col-12 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-12"><div className="svg-post-it" /><h2>Well-Being Score</h2></div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <span>{overallScoreInterpretation}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-6 overall-score">
                                                    <CircularProgressbar percentage={overallScore || 0} overallScoreColor={"#008fbe"} showText="Overall" rotation={0.00}/>
                                                </div>
                                            </div>
                                            <div className="row list-row well-being__individual">
                                                <div className="col-12">
                                                    <h3 className="score">Individual Score</h3>
                                                </div>
                                                <div className="col-12">
                                                    <div className="row">
                                                        {results}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        //hasDiscussion === true &&
                                        <div className="row well-being__discussion">
                                            <div className="col-12 maxWidth-content">
                                                <div className="row list-row">
                                                    <div className="col-12">
                                                        <div className="svg-discussion" />
                                                        <h3>Discussion{hasDiscussion === true && <span> Points</span>}</h3>
                                                    </div>
                                                    {hasDiscussion === true ?
                                                        <div className="col-12">
                                                            <h4>Discuss the following with your doctor:</h4>
                                                            <ul className="angle-bullets">
                                                                {discussion}
                                                            </ul>
                                                        </div> :
                                                        <div className="col-12">
                                                            <p>Find a doctor or specialist if you would like to discuss your wellness report.</p>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <WellnessGoals currentYear={currentYear} isWellnessReport={true} />
                                    <div className="row well-being__pledge">
                                        <div className="col-12 maxWidth-content">
                                            <div className="row list-row last">
                                                <div className="col-12">
                                                    <div className="svg-pledge" />
                                                    <h3>My Pledge</h3>
                                                    <span>{pledge}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>)

                    }
                </div>
            </div>
        </div>);

    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        report: state.thrive.report,
        reportPending: state.thrive.reportPending,
        reportSuccess: state.thrive.reportSuccess,
        reportError: state.thrive.reportError,
        userToken: state.domain.t,
        serverData: state.session.serverData,
        showDCJSelfEnrollToolTip: state.session.showDCJSelfEnrollToolTip,
        myChartId: state.domain.mc,
        dcjSelfOrderPending: state.dashboard.dcjSelfOrderPending,
        dcjSelfOrderSuccess: state.dashboard.dcjSelfOrderSuccess,
        dcjSelfOrderFailure: state.dashboard.dcjSelfOrderFailure,
        isProxyUser: state.domain.ip,
        hasMyChartLogin: state.domain.hm,
        bffDashboardData: state.dashboard.bffDashboardData,
        currentUser: state.domain.cu,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getWellnessReportV2: (token, reportYear) => {
            dispatch({ type: types.THRIVE_GET_REPORT, token, reportYear });
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WellnessReport));
